








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-check',

})
export default class ICheck extends Vue {

  @Prop({type: [String], default: '#2D9CDB'}) protected color!: string

}

